/**
 * Blogs 小猪宰汁
 * Date: 2023/3/2
 * filename：en.js
 */
export default {
  "探索":"explore",
  "招募":"recruitment",
  "资产":"asset",
  "绑定邮箱":"Bind email",
  '后结束当前关卡': "End the current level afterwards",
  '当前关卡已结束,正在结算中!': "The current level has ended and is currently being settled!",
  '玩法介绍': "Gameplay Introduction",
  '充能': "Charge",
  '本关我已充能': "I have already charged this level",
  '邮箱地址': "email address",
  '验证码': "code",
  '取消': "Cancel",
  '提交': "submit",
  '发送验证码': "Send code",
  '倒计时': "countdown",
  '邮箱地址为空': "Email address is empty",
  '邮箱格式不正确': "Email format incorrect",
  '请输入新邮箱': "Please enter a new email address",
  '邮箱绑定成功': "Email binding successful",
  '修改邮箱': "Change email",
  '请输入邮箱地址': "email address",
  '安全验证': "Security verification",
  '玩法说明': "Game Instructions",
  '购买燃料': "Purchase energy",
  '可用余额': "Available Balance",
  '请输入金额': "Please enter the amount",
  '充值': "Recharge",
  '发送成功': "Sent successfully",
  '金额不能为空': "The amount cannot be empty",
  '金额不能为0': "The amount cannot be 0",
  '发送金额最小为0.1': "The minimum amount for sending is 0.1",
  '充值成功': "Recharge successful",
  '选择充能': "Choose charging",
  '充能成功': "Charging successful",
  '历史': "history",
  '没有更多了': "No more",
  '闯关': "breakthrough",
  '燃料': "Energy Essence",
  '奖励': "reward",
  '关卡': "roadblocks ",
  '状态': "status",
  '时间': "time",
  '预约充能': "Appointment Charging",
  '实际充能': "Actual charging",
  '类型': "type",
  '余额': "balance",
  '您的燃料小于': 'Your energy essence is less than',
  '为了避免影响收益，请及时补充': 'To avoid affecting profits, please supplement in a timely manner',

  //招募页面
  '招募好友成为守护者': "Recruit friends to become guardians",
  '并购买基地物资即可获得分红': "Purchase base supplies to receive dividends",
  '我的好友': "My friend",
  '小区单数': "Area number",
  '招募奖励': "Recruitment rewards",
  '小区单数规则': "Area number rules",
  '关闭': "Close",
  '级别': "level",
  '静态收入极差': "Static income range",
  '平级收入极差': "Average income range",
  '每个好友招募可赚取一级以及二级好友参与探险奖励的': "Each friend recruited can earn first level and second level friend participation adventure rewards",
  '您': "you",
  '直推好友': "Direct referral friends",
  '二级好友': "Second level friend",
  '查看奖励规则': "View reward rules",
  '招募奖励以Ju币发放，可通过“我-发送”进行提现。': "Recruitment rewards are distributed in Ju coins and can be withdrawn through 'Me Send'.",

  //资产页面
  '今日收益': "Today's Earnings",
  '累计收益': "Cumulative Return",
  '我的推荐码': "My recommendation code",
  '提现': "withdraw",
  '兑换': "exchange",
  '基地': "base",
  '我的代币总价值': "The total value of my token",
  '我的算力': "My computing power",
  '历史记录': "history",
  '发送至': "Send to",
  '接收来至': "Received from",
  'Jucoin账户': "Jucoin account",
  '确定': "confirm",
  '您正在兑换': "You are redeeming",
  '至': "to",
  '得到金额': "Get the amount",
  '手续费：': "Service Charge:",
  '每当你兑换时，将收取': "Exchange will be charged",
  '的手续费': "handling fee",
  '兑换成功': "Redemption successful",
  '金额': 'amount',
  '我的基地': 'My Base',
  '奖励类型': 'Reward Type',
  '通关收益': 'Pass revenue',
  '通关节点收益': 'Node revenue',
  '兑换收益': 'Exchange revenue',
  '节点补偿': 'Node compensation',
  '兑换节点收益': 'Exchange node compensation',
  '购买': 'buy',
  '一级动态奖励': 'First level reward',
  '二级动态奖励': 'Second level reward',
  '团队奖励': 'Team Incentives',
  '成功': 'success',
  '失败': 'failure',
  '已撤回': 'Withdrawn',
  '审核拒绝': 'Rejected after review',
  '待审核': 'Pending review',
  '审核成功': 'Approved',
  '全部': 'all',
  '兑换成': 'Exchange for',
  'JUcoin账户': 'JUcoin account',


  //我的好友
  '邀请码': 'code',
  '团队人数': 'team size',
  '业绩': 'performance',
  '注册时间': 'time',

  '闯关成功': 'Level cleared',
  '恭喜你!': 'Congratulations!',
  '已通关，本轮您预约充能': 'Already cleared, you can make an appointment for charging in this round',
  '，已返还多余充能并成功获得以下奖励': '.Excess energy has been returned and the following rewards have been successfully obtained',
  '通关奖励': 'Clearance Rewards',


  //历史
  '加载中' : 'Loading',

  //注册
  '注册': 'register',
  '邀请人推荐码': 'Inviter recommendation code',
  '请输入邀请码': 'Please enter the invitation code',
  '邀请码不能为空': 'The invitation code cannot be empty',

  //闯关失败
  '闯关失败': 'Failed to clear the level',
  '很遗憾': 'Unfortunately',
  '关未通关，获得以下补偿': 'Failure to clear customs will result in the following compensation:',
  '闯关补偿': 'Compensation',
  '兑奖池补偿': 'Compensation',
  '收下': 'accept',


  '时':'hour',
  '天':'day',
  '分':'minute',
  '秒':'second',

  '推荐人邀请码':'Referrer invitation code',
  '退还':'Refund',
  '世界':'world'


};
